import { render, staticRenderFns } from "./RevenueRefund.vue?vue&type=template&id=0f95e954&"
import script from "./RevenueRefund.vue?vue&type=script&lang=js&"
export * from "./RevenueRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports